import PropTypes from 'prop-types';

export const shopShape = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  photos: PropTypes.arrayOf(PropTypes.object),
  address: PropTypes.string.isRequired,
  location: PropTypes.shape({
    coordinates: PropTypes.arrayOf(PropTypes.number),
  }),
  distance: PropTypes.number,
  zip: PropTypes.string.isRequired,
  yelpRating: PropTypes.number,
  yelpID: PropTypes.string,
});

export const barberShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  photos: PropTypes.arrayOf(PropTypes.object),
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  nextTimeFormatted: PropTypes.string,
});

export const serviceShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  cost: PropTypes.number.isRequired,
  desc: PropTypes.string,
});

export const categoryShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

export const categoriesShape = PropTypes.arrayOf(categoryShape);

export const dayShape = PropTypes.shape({
  date: PropTypes.string.isRequired,
  dayOfWeek: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
});

export const timeShape = PropTypes.shape({
  barberRoute: PropTypes.string,
  time: PropTypes.string,
});

export const timesShape = PropTypes.arrayOf(timeShape);

export const tipShape = PropTypes.shape({
  value: PropTypes.number.isRequired,
  amount: PropTypes.number.isRequired,
  desc: PropTypes.string.isRequired,
});

export const fieldPropTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  name: PropTypes.string,
  autoComplete: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  value: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
};

export const fieldShape = PropTypes.shape(fieldPropTypes);

export const positionShape = PropTypes.shape({
  lat: PropTypes.number,
  lng: PropTypes.number,
});

export const flag = PropTypes.bool;
export const handler = PropTypes.func;

export const stepShape = PropTypes.shape({
  key: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  trim: PropTypes.bool,
});
export const stepsShape = PropTypes.arrayOf(stepShape);

export const linkShape = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.shape({
    pathname: PropTypes.string,
    query: PropTypes.object,
  }),
]);

export const taxBreakdownShape = PropTypes.shape({
  name: PropTypes.string,
  amount: PropTypes.number,
  taxId: PropTypes.string,
});

export const taxBreakdownArray = PropTypes.arrayOf(taxBreakdownShape);



// WEBPACK FOOTER //
// ./src/app/shapes.js